import { SectionLabel } from '@perch/ui';
import { useScrollReveal } from '../../hooks/useScrollReveal';

export function PointsSection() {
  const textCol = useScrollReveal();
  const cardCol = useScrollReveal();

  return (
    <section className="relative py-32 px-4 sm:px-6 bg-stone-900 text-white overflow-hidden">
      {/* Grid pattern background */}
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)`,
          backgroundSize: '50px 50px',
        }}
      />

      <div className="max-w-5xl mx-auto relative">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div
            ref={cardCol.ref}
            className={`order-2 md:order-1 transition-[opacity,transform] duration-500 ease-out ${cardCol.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
            style={{ transitionDelay: '100ms' }}
          >
            {/* Points card mock - styled like TripCard */}
            <div className="relative overflow-hidden bg-gradient-to-br from-stone-800 to-stone-900 rounded-2xl p-6 border border-stone-700/50 shadow-xl">
              {/* Subtle amber glow for award booking */}
              <div className="absolute inset-0 bg-gradient-to-br from-amber-500/10 via-transparent to-amber-500/5 pointer-events-none" />

              <div className="relative">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-12 h-12 bg-gradient-to-br from-amber-500 to-amber-600 rounded-xl flex items-center justify-center shadow-lg shadow-amber-500/20">
                    <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  </div>
                  <div>
                    <div className="text-white font-medium">Award Booking</div>
                    <div className="text-stone-400 text-sm">Delta SkyMiles</div>
                  </div>
                </div>

                <div className="space-y-4">
                  <div className="flex justify-between items-center">
                    <SectionLabel>You Redeemed</SectionLabel>
                    <span className="text-white font-data tabular-nums text-lg">85,000 pts</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <SectionLabel>Current Price</SectionLabel>
                    <span className="text-emerald-400 font-data tabular-nums text-lg">67,500 pts</span>
                  </div>
                  <div className="border-t border-stone-700/50 pt-4 flex justify-between items-center">
                    <SectionLabel>Potential Savings</SectionLabel>
                    <div className="text-right">
                      <span className="text-2xl font-data tabular-nums text-emerald-400">17,500</span>
                      <span className="text-emerald-400/60 text-sm ml-1">pts</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            ref={textCol.ref}
            className={`order-1 md:order-2 transition-[opacity,transform] duration-500 ease-out ${textCol.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
          >
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-amber-500/20 rounded-full text-sm mb-6">
              <svg className="w-4 h-4 text-amber-400" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
              <SectionLabel variant="amber">Points & Miles</SectionLabel>
            </div>
            <h2 className="text-3xl sm:text-4xl font-serif mb-6 leading-tight">
              Points Are Currency Too
            </h2>
            <p className="text-lg text-stone-400 mb-8 leading-relaxed">
              We track award availability alongside cash prices. When saver space opens up or
              point costs drop, we rebook you and get those miles back.
            </p>
            <p className="text-stone-500">
              Works with airline and hotel loyalty programs. Same simple process —
              add your confirmation, we do the rest.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
